import { PropsWithChildren } from "react";

import { Dialog, IDialogProps } from "@bps/fluent-ui";

export interface JobDialogProps
  extends Pick<IDialogProps, "onDismiss" | "hidden"> {
  modeLabel: "Edit" | "Add";
}

export const JobDialog: React.FC<PropsWithChildren<JobDialogProps>> = ({
  modeLabel,
  children,
  ...props
}) => {
  return (
    <Dialog
      dialogContentProps={{
        showCloseButton: true,
        title: `${modeLabel} Job`
      }}
      minWidth="30%"
      maxWidth="30%"
      {...props}
    >
      {children}
    </Dialog>
  );
};
